import { APP_ORGANIZATION } from "theme/config/constants";
import Image from "core-web/components/Image";
import LRQA from "theme/components/icons/LrqaCert";
import Link from "core-web/components/Link";
import PropTypes from "prop-types";
import React from "react";
import Row from "theme/layouts/Row";
import TextStyles from "theme/components/text/TextStyles";
import styled from "theme/libs/styled";
import { useSelector } from "react-redux";

const Wrapper = styled("div")`
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    grid-template-areas:
        "icon"
        "partners"
        "copyright";

    ${({ theme }) => theme.above.tabletLg} {
        grid-template-columns: 1fr 1fr;
        gap: 22px;
        grid-template-areas:
            "icon icon"
            "copyright partners";
    }
`;

const Partners = styled(Row)`
    grid-area: partners;
    gap: 4px 20px;
    flex-wrap: wrap;

    ${({ theme }) => theme.above.tabletLg} {
        justify-content: end;
        gap: 20px;
    }

    div {
        width: unset;
        height: unset;
    }
`;

const Copyright = styled(TextStyles)`
    grid-area: copyright;
`;

const BottomRow = () => {
    const partners = useSelector(({ footer }) => footer.data?.partners) || [];

    const date = new Date();

    const copyrightName =
        useSelector(({ application }) => application?.config?.options?.company_data?.organization?.company_name) ||
        APP_ORGANIZATION;

    return (
        <Wrapper>
            <LRQA gridArea="icon" mb={["44px", null, null, null, "0"]} />
            <Copyright textStyles="Myriad Pro/14-140">{`© ${copyrightName} ${date.getFullYear()}`}</Copyright>

            {!!partners.length && (
                <Partners>
                    {partners.map(
                        ({ url, icon, name }) =>
                            icon && (
                                <Link key={`${name}-${icon.url}`} to={url ? url : undefined}>
                                    <Image
                                        alt={name}
                                        src={{
                                            url: icon.url,
                                            width: 60,
                                        }}
                                        width="auto"
                                        height="auto"
                                        maxWidth="58px"
                                        maxHeight="20px"
                                        verticalAlign="middle"
                                    />
                                </Link>
                            ),
                    )}
                </Partners>
            )}
        </Wrapper>
    );
};

BottomRow.propTypes = {
    partners: PropTypes.array,
};

BottomRow.defaultProps = {
    partners: [],
};

export default BottomRow;
